"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const PdfScreen = ({ route, navigation }) => {
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 } }));
};
exports.default = PdfScreen;
